module.exports = __webpack_public_path__ + "static/media/technical_parts.20bcf663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/technicalProducts/technical_parts.jpg
// module id = 216
// module chunks = 0